export default __webpack_public_path__ + "static/media/line-mobile-1.42a249e1.svg";